import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./../styles/ChatWithWhatsappBtn.style.css";

export default function ChatWithWhatsappBtn() {
  return (
    <a
      id="whatsappWidgetContainer"
      className="chat-with-whatsapp"
      href="https://api.whatsapp.com/send?phone=%2B919650727918&amp;text=Hi%2C%20I%20have%20a%20query%20regarding%20your%20learning%20community."
      target="_blank"
    >
      <div className="whatsapp-widget-icon">
        <FontAwesomeIcon icon={faWhatsapp} className="" color="#ffffff" />
      </div>
      <div className="_label">Contact us</div>
    </a>
  );
}
